<template>
  <section class="fill-width fill-height">
    <template v-if="resultData.contentList.length > 0">
      <div class="mb-5">
        <LoadImage min-height="180px"
                   :src="$downUrl(resultData.dlgtImgAtchFileName)" />
        <div class="fs-18 fw-500 pa-5">
          {{ resultData.title }}
        </div>
        <v-divider />
        <div class="fs-14 gray200--text py-4 px-5">
          {{resultData.wrtrNm}}
        </div>
      </div>
      <div class="mb-5" v-for="(item, idx) in resultData.contentList" :key="idx">
        <LoadImage contain
                   aspect-ratio="1"
                   :src="$downUrl(item.imgAtchFileName)" />
        <div class="ma-5" v-html="item.content"></div>
      </div>
    </template>
    <template v-else>
      <slot name="no-data">
        <NoData />
      </slot>
    </template>
  </section>
</template>

<script>
export default {
  props: {
    resultData: {
      type: Object,
      default: () => ({
        title: null,
        wrtrNm: null,
        dlgtImgAtchFileName: null,
        contentList: []
      })
    }
  }
}
</script>
